import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { useProjectContext } from "~/areas/projects/context/ProjectContext";
import InternalRedirect from "~/components/Navigation/InternalRedirect";
export default function ProjectTenantVariablesRedirect() {
    const projectContext = useProjectContext();
    const project = projectContext.state.model;
    return <InternalRedirect to={links.tenantVariablesProjectTemplatesPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug })}/>;
}
